import * as React from 'react'
import { connect } from 'react-redux'
import { IDetailPageState } from '../../reducers'
import { Collection } from '../collection/collection'
import { Tabs, TabSection } from '@amzn/dvui/dist/Tabs'
import * as st from './collectionTabs.module.scss'
import { isTabSupportedCollection} from '../collection/collectionTypes'
import { isEmpty } from '../../utils/utils'
import {
  sanitizedCollectionsSelector,
  ISanitizedCollections
} from '../../selectors/collections'

export interface ICollectionProps {
  collections: ISanitizedCollections,
  useBtfTab: boolean
}

export const ConnectedCollectionTabs = ({ collections, useBtfTab }: ICollectionProps) => {
  const tabs = collections.map((col, idx) => {
    if (col === null) return null
    if (isTabSupportedCollection(col.collectionType) && useBtfTab) {
      return <TabSection
        key={`tab-${idx}`}
        isSelected={idx === 0}
        name={`${col.header} (${col.totalEpisodeSize})`}
      >
        <Collection {...col} hideHeader={true} key={`collection-${col.index}-${idx}`}/>
      </TabSection>
    }
  }).filter(Boolean)

  return isEmpty(tabs) ? null : <div className={st.tabsWrapper}><Tabs> {tabs} </Tabs></div>
}

const mapStateToProps = (state: IDetailPageState): ICollectionProps => ({
  collections: sanitizedCollectionsSelector(state),
  useBtfTab: state.features.useBtfTab
})

export const CollectionTabs = connect(mapStateToProps)(ConnectedCollectionTabs)
